export default __webpack_public_path__ + "static/media/Loading_icon.12014b48.gif";